// Generated by ReScript, PLEASE EDIT WITH CARE


let sdkDomainUrl = __SDK_CONFIG__.sdkUrl + __SDK_CONFIG__.publicPath;

let apiEndPoint = {
  contents: undefined
};

function setApiEndPoint(str) {
  apiEndPoint.contents = str;
}

function getApiEndPoint(publishableKeyOpt, isConfirmCallOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  let isConfirmCall = isConfirmCallOpt !== undefined ? isConfirmCallOpt : false;
  let testMode = publishableKey.startsWith("pk_snd_");
  let str = apiEndPoint.contents;
  if (str !== undefined) {
    return str;
  }
  let backendEndPoint = isConfirmCall ? __SDK_CONFIG__.confirmEndPoint : __SDK_CONFIG__.backendEndPoint;
  if (__SDK_CONFIG__.isProductionEnv && testMode) {
    return "https://beta.hyperswitch.io/api";
  } else {
    return backendEndPoint;
  }
}

function hyperswitchVaultEndPoint(publishableKeyOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  let testMode = publishableKey.startsWith("pk_snd_");
  if (__SDK_CONFIG__.isProductionEnv && !testMode) {
    return "https://checkout.hyperswitch.io/api";
  } else if (__SDK_CONFIG__.isIntegrationEnv) {
    return "https://dev.hyperswitch.io/api";
  } else {
    return "https://beta.hyperswitch.io/api";
  }
}

function getVaultEndPoint(publishableKeyOpt) {
  let publishableKey = publishableKeyOpt !== undefined ? publishableKeyOpt : "";
  if (__SDK_CONFIG__.isPciCompliant || __SDK_CONFIG__.isLocal) {
    return getApiEndPoint(publishableKey, undefined);
  } else {
    return hyperswitchVaultEndPoint(publishableKey);
  }
}

let hyperswitchVaultSdkUrl = __SDK_CONFIG__.isProductionEnv ? "https://checkout.hyperswitch.io" : (
    __SDK_CONFIG__.isSandboxEnv ? "https://beta.hyperswitch.io" : "https://dev.hyperswitch.io"
  );

let vaultSdkDomainUrl = __SDK_CONFIG__.isPciCompliant || __SDK_CONFIG__.isLocal ? sdkDomainUrl : hyperswitchVaultSdkUrl + __SDK_CONFIG__.publicPath;

function addCustomPodHeader(arr, customPodUri) {
  if (customPodUri !== undefined && customPodUri !== "") {
    arr.push([
      "x-feature",
      customPodUri
    ]);
  }
  return Object.fromEntries(arr);
}

let switchToInteg = false;

let isLocal = false;

export {
  switchToInteg,
  isLocal,
  sdkDomainUrl,
  apiEndPoint,
  setApiEndPoint,
  getApiEndPoint,
  hyperswitchVaultEndPoint,
  getVaultEndPoint,
  hyperswitchVaultSdkUrl,
  vaultSdkDomainUrl,
  addCustomPodHeader,
}
/* sdkDomainUrl Not a pure module */
